import React from 'react';
import { Section } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-3xl" data-id="element-36">
      <div className="glass-panel p-8 md:p-12 rounded-3xl text-center bg-white/80 border-brand-pink/30 shadow-lg" data-id="element-37">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-8 text-brand-text" data-id="element-38">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-6 text-lg text-brand-text/80 mb-10" data-id="element-39">
          <p data-id="element-40">Una que cierra esta página y el domingo que viene sigue igual.</p>
          <p className="font-medium text-brand-gold" data-id="element-41">
            Y otra que decide que hoy es diferente.
          </p>
          <p data-id="element-42">$19.990 pesos. 10 minutos por día. 180 días.</p>
          <p className="font-serif italic text-xl" data-id="element-43">
            La pregunta no es si podés pagarlo.
            <br data-id="element-44" />
            La pregunta es si podés seguir sin hacerlo.
          </p>
        </div>

        <div className="text-sm text-brand-text/60 bg-brand-surfaceLight/20 p-6 rounded-2xl border border-brand-pink/20 pt-[2px] pb-[2px] pl-[2px] pr-[2px] space-y-[10px]" data-id="element-45">
          <p data-id="element-46">
            <strong className="text-brand-text/80" data-id="element-47">P.D.:</strong> Tenés dudas.
            Escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-gold hover:underline" data-id="element-48">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-gold hover:underline" data-id="element-49">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p data-id="element-50">
            <strong className="text-brand-text/80" data-id="element-51">P.D. 2:</strong> El precio de
            $19.990 es de lanzamiento. Sube pronto. El mejor momento para
            empezar es ahora.
          </p>
        </div>
      </div>
    </Section>;
};